export const PRIVILEGE = {
    BRAND: {
        BRAND: {
            CREATE: 'brand.brand.create',
            EDIT: 'brand.brand.edit'
        }
    },
    AGENCY: {
        USER: {
            INDEX: 'agency.user.create',
            CREATE: 'agency.user.create',
            EDIT: 'agency.user.edit',
            DESTROY: 'agency.user.destroy'
        }
    },
    CAMPAIGN: {
        CAMPAIGN: {
            SHOW: 'campaign.campaign.show',
            EDIT: 'campaign.campaign.edit',
            CREATE: 'campaign.campaign.create'
        },
        APPLICATION: {
            PROCESS: 'campaign.application.process',
            INDEX: 'campaign.application.index'
        },
        COLLABORATION: {
            PROCESS: 'campaign.collaboration.process',
            INDEX: 'campaign.collaboration.index'
        },
        PERFORMANCE: {
            INDEX: 'campaign.performance.index'
        },
        PAYMENT: {
            INDEX: 'campaign.payment.index'
        }
    },
    WALLET: {
        SHOW: 'campaign.campaign.show',
        CREATE: 'campaign.campaign.show'
    }
}